/**
 * Собирает presentation ПЛАНа и ФАКТа внутри домена расчёта заказа без привязки к пользовательским
 * кодам калькулятора. Утилита не рассчитывает финансовые показатели: итоговые
 * суммы и значения ФАКТа всегда приходят с backend.
 */

/**
 * Возвращает сохранённое значение параметра по его системной семантической роли.
 * Пользовательские code и порядок закреплений на смысл сравнения не влияют.
 */
export function findPlanSemanticValue(plan, semanticKey) {
  const param = (plan?.preset_snapshot?.params || [])
    .find((candidate) => candidate.semantic_key === semanticKey);
  if (!param?.code) return null;

  return (plan?.breakdown || [])
    .find((candidate) => candidate.code === param.code)?.value ?? null;
}

/**
 * Возвращает только геометрию полосы и процент отклонения пробега.
 * Денежные значения ФАКТа эта функция не вычисляет.
 */
export function buildMileageComparison(actualValue, planValue) {
  const actual = toPositiveNumber(actualValue);
  const plan = toPositiveNumber(planValue);
  if (actual === null || plan === null) {
    return {
      actualPercent: actual === null ? 0 : 100,
      planPercent: plan === null ? 0 : 100,
      differencePercent: null,
    };
  }

  const maximum = Math.max(actual, plan);
  return {
    actualPercent: roundToTenth((actual / maximum) * 100),
    planPercent: roundToTenth((plan / maximum) * 100),
    differencePercent: Math.round(((actual - plan) / plan) * 100),
  };
}

/**
 * Подпись времени последней проверки телеметрии зависит от того, какое
 * значение сейчас показано пользователю. Ручной override не скрывает время
 * фонового телеметрического значения, с которым его можно сравнить.
 */
export function buildTelemetryFreshnessLabel({
  formattedAt = "",
  hasTelemetry = false,
  overridden = false,
  refreshPending = false,
} = {}) {
  if (refreshPending) return "обновляем…";
  if (!formattedAt) return hasTelemetry ? "данные не обновлялись" : "ещё не проверено";
  if (overridden && hasTelemetry) return `телеметрия на ${formattedAt}`;
  return `${hasTelemetry ? "данные на" : "проверено"} ${formattedAt}`;
}

/** Сравнивает число из поля с применённым пробегом, игнорируя форматирование. */
export function isMileageDraftChanged(draft, appliedValue) {
  const draftNumber = parseMileageValue(draft);
  const appliedNumber = parseMileageValue(appliedValue);
  if (draftNumber === null && appliedNumber === null) return false;

  return draftNumber !== appliedNumber;
}

function toPositiveNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

function parseMileageValue(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(String(value).replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(number) ? number : null;
}

function roundToTenth(value) {
  return Math.round(value * 10) / 10;
}
